"use client";

import { useLayoutEffect, useState } from "react";

import { QuantityStepper } from "@/app/blu/(checkout-flow)/components/quantityStepper/quantityStepper.component";

const getVariantProductId = (cardId: string) =>
  document
    .querySelector(`[data-product-card-id="${cardId}"] input[name="variantId"]`)
    ?.getAttribute("value") ?? null;

export const ProductTileQuantityStepper = ({
  id,
  basketItems = {},
  quantity,
  ...props
}: ProductTileQuantityStepperProps) => {
  const [effectiveProductId, setEffectiveProductId] = useState(id);

  useLayoutEffect(() => {
    setEffectiveProductId(getVariantProductId(id) || id);
  });

  const resolvedQuantity = quantity ?? basketItems[effectiveProductId] ?? 0;

  return <QuantityStepper id={id} quantity={resolvedQuantity} {...props} />;
};

type ProductTileQuantityStepperProps = Omit<
  React.ComponentProps<typeof QuantityStepper>,
  "quantity"
> & {
  basketItems?: Record<string, number>;
  quantity?: number;
};
